module.exports = __webpack_public_path__ + "images/STACK_BOTTOM.png?v=9903381e12bcf32e5b05d8608cc675ab";